<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page-vii"></a><em>To our very own Riley. And to Kelly and <br/>Courtney, Annie, Nicole, Gabby, Aubrey, <br/>Macey, Kelsey, and Haley.</em></p>
<p class="ded1"><em>And, as always, to my love, my best friend, Tom</em>.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?16cd2a82